if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      /* CUSTOM SLIDER >> */

      const buttonsDiv = `<div id='product-media-modal__content--buttonDiv' class='slider-buttons no-js-hidden'>
          <a id='product-media-modal__content--buttonPrev' class='slider-button slider-button--prev previous' name='previous' aria-label='Slide left'>        
          </a>
          <a id='product-media-modal__content--buttonNext' class='slider-button slider-button--next next' name='next' aria-label='Slide right'>
          </a>
        </div>`;
      this.insertAdjacentHTML('afterbegin', buttonsDiv);

      this.sliderContainer = this.querySelector('.product-media-modal__content')
      this.allImages = this.querySelectorAll('img.global-media-settings');

      this.btnNext = this.querySelector('#product-media-modal__content--buttonNext');
      this.btnPrev = this.querySelector('#product-media-modal__content--buttonPrev');

      this.btnNext.addEventListener('click', this.onButtonClick.bind(this));
      this.btnPrev.addEventListener('click', this.onButtonClick.bind(this));

      /* << CUSTOM SLIDER */

    }

    /* CUSTOM SLIDER >> */

    onButtonClick(event) {
      let isDesktop = (window.innerWidth >= 768 ) ? true : false;
      if(isDesktop) {
        let currentYTop = this.sliderContainer.scrollTop;
        let arrImages = [], goal = currentYTop;

        this.allImages.forEach((img, index)=>{
          let imgYTop = img.offsetTop;
          arrImages.push(imgYTop)
        });

        let closest = arrImages.reduce(function(prev, curr) {
          return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
        });

        const isClosest = (element) => element === closest;

        let currentImage = this.allImages[arrImages.findIndex(isClosest)],
            currentImagePos = Array.prototype.indexOf.call(this.allImages,currentImage),
            posToScrollTo;

        if(event.currentTarget.name === 'next') {
          if(this.allImages[currentImagePos + 1]) {
            posToScrollTo = this.allImages[currentImagePos + 1].offsetTop

            this.btnPrev.removeAttribute('disabled');

            if(typeof(this.allImages[currentImagePos + 2]) === 'undefined') {
              this.btnNext.setAttribute('disabled', 'disabled');
            }
          }
        } else {
          if(this.allImages[currentImagePos - 1]) {
            posToScrollTo = this.allImages[currentImagePos - 1].offsetTop;

            this.btnNext.removeAttribute('disabled');

            if(typeof(this.allImages[currentImagePos - 2]) === 'undefined') {
              this.btnPrev.setAttribute('disabled', 'disabled');
            }
          }
        }

        if(!posToScrollTo && posToScrollTo != 0) return;

        this.sliderContainer.scrollTo({
          top: posToScrollTo,
          behavior: 'smooth'
        });
      } else {
        let currentXLeft = this.sliderContainer.scrollLeft;
        let arrImages = [], goal = currentXLeft;

        this.allImages.forEach((img, index)=>{
          let imgXLeft = img.offsetLeft;
          arrImages.push(imgXLeft)
        });

        let closest = arrImages.reduce(function(prev, curr) {
          return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
        });

        const isClosest = (element) => element === closest;

        let currentImage = this.allImages[arrImages.findIndex(isClosest)],
            currentImagePos = Array.prototype.indexOf.call(this.allImages,currentImage),
            posToScrollTo;

        let notSmooth = false;
        function getImgCenteredOffsetLeft(img) {
          let res = (img) ? ((img.offsetLeft + (img.offsetWidth / 2)) - (window.innerWidth / 2)) : 0;
          return res;
        }

        if(event.currentTarget.name === 'next') {
          if(this.allImages[currentImagePos + 1]) {
            posToScrollTo = getImgCenteredOffsetLeft(this.allImages[currentImagePos + 1]);
          } else {
            /* restart - infinite loop */
            if(typeof(this.allImages[currentImagePos + 1]) === 'undefined') {
              notSmooth = true;
              posToScrollTo = getImgCenteredOffsetLeft(this.allImages[0]);
            }
          }
        } else {
          if(this.allImages[currentImagePos - 1]) {
            posToScrollTo = getImgCenteredOffsetLeft(this.allImages[currentImagePos - 1]);
          } else {
            /* restart - infinite loop */
            if(typeof(this.allImages[currentImagePos - 1]) === 'undefined') {
              notSmooth = true;
              posToScrollTo = getImgCenteredOffsetLeft(this.allImages[arrImages.length - 1]);
            }          }
        }

        if(typeof(posToScrollTo) === 'undefined') return;

        this.sliderContainer.scrollTo({
          left: posToScrollTo,
          behavior: (notSmooth) ? 'instant' : 'smooth'
        });
      }
    }

    /* << CUSTOM SLIDER */

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();

      /* disabled arrow on modal opening if first or last img */
      let isDesktop = (window.innerWidth >= 768 ) ? true : false;
      if(isDesktop) {
        let currentImage = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`),
            currentImagePos = Array.prototype.indexOf.call(this.allImages,currentImage);
        if( currentImagePos === 0) {
          this.btnPrev.setAttribute('disabled', 'disabled');
        }
        if(currentImagePos === (this.allImages.length - 1)) {
          this.btnNext.setAttribute('disabled', 'disabled');
        }
      }
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
